export default "__VITE_ASSET__b53603ae__"